import { Kaggle } from "@kaggle/sdk";
import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { ExternalSourceDataActionKey as ActionKey } from "./ActionKeys";

import ExternalSourceData = Kaggle.Sdk.Kernels.ExternalSourceData;

export interface SetExternalSourceDataAction
  extends AppAction<
    ActionKey.SET_EXTERNAL_SOURCE_DATA,
    {
      externalSourceData: ExternalSourceData | null;
    }
  > {}

export type ExternalSourceDataAction = SetExternalSourceDataAction;

export const setExternalSourceData = (
  sourceDescription: string | null,
  isPublic: boolean = false
): SetExternalSourceDataAction =>
  getStore().dispatch({
    type: ActionKey.SET_EXTERNAL_SOURCE_DATA,
    payload: {
      externalSourceData: sourceDescription
        ? {
            sourceDescription,
            isPublic,
          }
        : null,
    },
  });
